import { Injectable } from "@angular/core";
import snake_case from 'lodash.snakecase';
import { Observable } from "rxjs";
import { NotifiactionPaginatedListResponse, Notification } from "src/app/interfaces/notification";
import { Profile } from "src/app/interfaces/user";
import { environment } from "src/environments/environment";
import { customLocalStorage } from "src/utils/utils";
import { CustomHttpClient } from "../http/http.service";

@Injectable({
  providedIn: "root"
})
export class NotificationService {

  constructor(
    private http: CustomHttpClient
  ) { }

  get latestReadNotificationId(): number {
    const id: string | null = customLocalStorage.getItem('latestReadNotificationId');
    if (id === null) {
      return 0;
    }
    return +id;
  }

  set latestReadNotificationId(id: number) {
    customLocalStorage.setItem('latestReadNotificationId', `${id}`);
  }

  getNotificationList(cursor: string | null = null, pageSize = 10): Observable<NotifiactionPaginatedListResponse> {
    const queryParams = { cursor, pageSize };
    return this.http.get<NotifiactionPaginatedListResponse>(`${environment.apiUrl}/v1/notification/mine`, { queryParams });
  }

  parseContent(noti: Notification): string {
    let formattedInAppContent = noti.inAppContent;
    for (const key in noti.formatData.inAppContent) {
      formattedInAppContent = formattedInAppContent.replace(
        '{' + snake_case(key) + '}',
        `<b>${noti.formatData.inAppContent[key]}</b>`
      )
    }
    const profile: Profile | null = noti.senderProfile;
    if (profile) {
      return formattedInAppContent
        .replace('{username}', `<b>${profile?.firstName ?? ''}</b>`)
    } else {
      const formatData = noti.formatData.inAppContent;
      return formattedInAppContent
        .replace('{username}', `<b>${formatData?.username ?? ''}</b>`)
    }
  }
}